export const NUMBER_OF_ROWS_IN_GRID = 4;
export const WINDOW_WIDTH_SIZE_XSMALL = 350;

